import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Tabs,
  Tab,
  Switch
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
import AreasOfWorkSection from "../../sections/AreasOfWorkSection";
import useApi from "../../../api/useApi";
import { toast } from "react-toastify";
import {  useLocation, useNavigate, useNavigation } from "react-router";
import { Categorydelete } from "../../../api/orgService";
import ConfirmDeleteDialog from "../Consumer/ConfirmDeleteDialog";

export default function CategoryAdmin({ onAddcategory }) {
  const CATEGORY_FORM_STORAGE_KEY = "categoryFormState";
  const location = useLocation();
  const navigate = useNavigate()
  const [uploadingImage, setUploadingImage] = useState(false);

  const [openDelete, setOpenDelete] = useState(false);
//   const [loadingDelete, setLoadingDelete] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [category, setCategory] = useState({
    name: "",
    category_alias: "",
    description: "",
    link: "",
    image_introduction: "",
    released: false,
  });

  const [showall,setShowall]=useState(false)

  const [tabPreviewCreate, setTabPreviewCreate] = useState(0); // 0 = New, 1 = Preview
  const [tabIndex, setTabIndex] = useState(0); // 0 = Link, 1 = Upload
  const fileInputRef = useRef(null);

  // API hook
  const {
    request: createCategory,
    data: createCategoryData,
    error: createCategoryError,
  } = useApi(onAddcategory);

  const {
    request: deleteCategory,
    data: deleteCategoryData,
    error: deleteCategoryError,
    loading: deleteCategoryLoading,
    clearHook
  } = useApi(Categorydelete);

  useEffect(() => {
    if (createCategoryData?.status === 200) {
      toast.success(`${JSON.stringify(createCategoryData?.data, null, 2)}`, {
        position: "top-center",
      });
      window.localStorage.removeItem(CATEGORY_FORM_STORAGE_KEY);
      setCategory({
        name: "",
        category_alias: "",
        description: "",
        link: "",
        image_introduction: "",
        released: false,
      });
      clearHook()
    navigate(-1,{state: {refresh:"category"}})
    }
  }, [createCategoryData]);

  useEffect(() => {
    if (deleteCategoryData?.status === 200) {
      toast.success(`${JSON.stringify(deleteCategoryData?.data, null, 2)}`, {
        position: "top-center",
      });
      window.localStorage.removeItem(CATEGORY_FORM_STORAGE_KEY);
      setCategory({
        name: "",
        category_alias: "",
        description: "",
        link: "",
        image_introduction: "",
        released: false,
      });
      clearHook()
    navigate(-1,{state: {refresh:"category"}})
    }
    
    

  }, [deleteCategoryData]);

  useEffect(() => {
    if (createCategoryError) {
      toast.error(
        `${JSON.stringify(createCategoryError?.response?.data, null, 2)}`,
        { position: "top-center" }
      );
    }
  }, [createCategoryError]);

  useEffect(() => {
    if (deleteCategoryError) {
      toast.error(
        `${JSON.stringify(deleteCategoryError?.response?.data, null, 2)}`,
        { position: "top-center" }
      );
    }
  }, [deleteCategoryError]);

  useEffect(()=>{
    let categoryData2 = location?.state?.category;
    if(categoryData2){
        console.log("cat: ",categoryData2)
        setTabPreviewCreate(0)
        setCategory({... categoryData2}) 
        // setCategory({
        //     name: categoryData2?.name,
        //     category_alias: categoryData2?.category_alias,
        //     description: categoryData2?.description,
        //     link:categoryData2?.link,
        //     image_introduction: categoryData2?.image_introduction,
        //     released: categoryData2?.released,
        //   });
        }

  }, [location?.state?.category])

  useEffect(()=>{
    let categoryData2 = location?.state?.category;
    if(categoryData2){
        console.log("cat: ",categoryData2)
        setTabPreviewCreate(0)
        setCategory({... categoryData2}) 
        // setCategory({
        //     name: categoryData2?.name,
        //     category_alias: categoryData2?.category_alias,
        //     description: categoryData2?.description,
        //     link:categoryData2?.link,
        //     image_introduction: categoryData2?.image_introduction,
        //     released: categoryData2?.released,
        //   });
        }

  }, [location?.state?.category])

  const generateAlias = () => {
    const name = category?.name.trim();
    const alias = name.toLowerCase().replace(/\s+/g, "-");
    return alias;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategory((prev) => ({ ...prev, [name]: value }));
    window.localStorage.setItem(
      CATEGORY_FORM_STORAGE_KEY,
      JSON.stringify(category)
    );
  };

  const handleCancelAndBack = (e)=>{
    e.preventDefault()
    navigate(-1)
  }

  const handleShowAll = (e)=>{
    e.preventDefault()
    setShowall(!showall)
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setCategory((prev) => ({ ...prev, value: previewUrl }));

      const formData = new FormData();
      formData.append("image", file);
      setUploadingImage(true);

      try {
        const res = await fetch("https://fountainafrica.org/cms/ftp-files/", {
          method: "POST",
          body: formData,
        });

        if (res?.status === 201) {
          const result = await res.json();
          setCategory((prevData) => ({
            ...prevData,
            image_introduction: result?.path,
          }));
          setUploadingImage(false);
        } else {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleSubmit = () => {
    if (!category?.name) return alert("Please provide a name value.");
    setCategory();
    createCategory(category?.id,{
        id: category?.id,
        name: category?.name,
        category_alias: category?.category_alias,
        description: category?.description,
        link: category?.link,
        image_introduction: category?.image_introduction,
        released: category?.released,
      });
  };

  const handleDelete = async () => {
    if (!category?.name) return alert("Please provide a name value.");
    deleteCategory(category?.id);
  };

  useEffect(() => {
    // const saved = window.localStorage.getItem(CATEGORY_FORM_STORAGE_KEY);
    // if (saved) {
    //   try {
    //     const obj = JSON.parse(saved);
    //     setCategory(obj);
    //   } catch (err) {
    //     console.error("Could not parse saved category form state", err);
    //   }
    // }
  }, []);

  useEffect(() => {
    if (category?.name?.length > 0) {
      setCategory((prev) => ({
        ...prev,
        category_alias: generateAlias(),
      }));
      setCategory((prev) => ({
        ...prev,
        link: `/what-we-do/${generateAlias()}`,
      }));
      window.localStorage.setItem(
        CATEGORY_FORM_STORAGE_KEY,
        JSON.stringify(category)
      );
    }
  }, [category?.name]);

  console.log("cate: ",category)

  return (
    <Box sx={{ 
        maxWidth: "80%", 
        mx: "auto", 
        mt: 4, 
        p: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        View/Edit Working Area Category
      </Typography>

      <Typography sx={{ mb: 4 }}>
        Add a new activity category (what we do category) that represents the
        areas your organization works in — such as Health, Education,
        Environment, or Media. These categories help group and organize your
        organization’s projects and initiatives.
      </Typography>

      

      <Tabs
        value={tabPreviewCreate}
        onChange={(e, newValue) => setTabPreviewCreate(newValue)}
        centered
        sx={{ mb: 2 }}
      >
        <Tab label="View/Edit Category" />
        <Tab label="Preview" />
      </Tabs>

      {tabPreviewCreate === 0 ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            name="name"
            label="Category Name"
            value={category?.name}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            name="category_alias"
            label="Category Alias"
            placeholder="Generated alias"
            value={category?.category_alias}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            name="description"
            label="Description (optional)"
            value={category?.description}
            onChange={handleChange}
            fullWidth
            multiline
            minRows={4}
          />

          <Tabs
            value={tabIndex}
            onChange={(e, newValue) => setTabIndex(newValue)}
            centered
            sx={{ mb: 1 }}
          >
            <Tab label="Category Image Introduction Link" />
            <Tab label="Upload Category Image Introduction" />
          </Tabs>

          {tabIndex === 0 ? (
            <TextField
              name="image_introduction"
              label="Image Link"
              value={category?.image_introduction}
              onChange={handleChange}
              fullWidth
            />
          ) : (
            <Box
              sx={{
                border: "2px dashed #ccc",
                borderRadius: 2,
                p: 3,
                textAlign: "center",
              }}
            >
              {category?.image_introduction ? (
                <img
                  src={category.image_introduction}
                  alt="preview"
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    marginBottom: "8px",
                  }}
                />
              ) : (
                <UploadIcon sx={{ fontSize: 50, color: "#aaa", mb: 1 }} />
              )}

              <Button
                variant="outlined"
                onClick={() => fileInputRef.current.click()}
                loading={uploadingImage}
              >
                {category?.image_introduction
                  ? "Click to Change File"
                  : "Click to Upload File"}
              </Button>
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </Box>
          )}

        {/* <Box> */}
          <Button
            variant="contained"
            // startIcon={<SaveIcon />}
            onClick={handleSubmit}
            // sx={{ alignSelf: "flex-start", mt: 2 }}
            fluid
          >
            Save Category
          </Button>
          <Button
            variant="contained"
            // startIcon={<AddIcon />}
            onClick={handleCancelAndBack}
            // sx={{ alignSelf: "flex-start", mt: 2 }}
            color="error"
            fluid
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
            setSelectedItem(`${category?.name}`);
            setOpenDelete(true);
            }}
        >
            Delete ICategory
        </Button>
          {/* <ConfirmDeleteDialog onConfirm={handleDelete} /> */}
        <ConfirmDeleteDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={handleDelete}
        loading={deleteCategoryLoading }
        itemName={selectedItem}
        title="Delete Category"
        message="This will permanently remove the selected category and its associated subcategories."
      />
          {/* </Box> */}
        </Box>
      ) : (
      <div>
          {showall===true?(<span className="text-sm">Show Single</span>):(<span className="text-sm">Show All</span>)}
          <Switch
            checked={showall}
            onChange={handleShowAll}
            color="primary"
          />
          <AreasOfWorkSection singleView={[category,]} all = {showall}/>
        </div>
      )}
    </Box>
  );
}
